'use strict';

define([], function() {
  // Elements to search for (order matters)
  var leaves = [];

  // Elements to filter out of results
  var filters = [
    '[class^=comment]',
    '[id^=comment]',
    '[class*=footer]',
    '[class^=comment]',
    '.archive-page',
    '.aside',
    '.hentry-metro',
    '.hrf-entry',
  ];

  // Elements to filter out of results (recursively filters out child nodes as well)
  var invalidParents = [
    '.sidebar:not(body)',
    'aside',
    '.aside',
    '#sidebar',
    'footer',
    '[class*=footer]:not(body):not([class*=not-footer])',
    '#comments',
    '#livefyre-comments',
    '[class^=fyre]',
    '[id^=comment]',
    '[class*=related-post]:not(body)',
    '.tve-leads-lightbox',
  ];

  // Elements to remove from possible results (leave blank)
  var invalidElements = [];

  var articles = {
    /**
    * Adds element and all children to invalidElements array
    */
    _invalidateNode: function(element) {
      if (!element) return;

      if (element.nodeName === '#text') return;

      invalidElements.push(element);
      if (element.childNodes && element.childNodes.length > 0) {
        for (var i = 0; i < element.childNodes.length; i++) {
          this._invalidateNode(element.childNodes[i]);
        }
      }
    },
    /**
    * Search page for all invalid nodes (defined in variable invalidParents)
    */
    _findInvalidElements: function(baseElement) {
      for (var i = 0; i < invalidParents.length; i++) {
        var selector = invalidParents[i];
        var parents = baseElement.querySelectorAll(selector);

        for (var j = 0; j < parents.length; j++) {
          this._invalidateNode(parents[j]);
        }
      }
    },
    /**
    * Find anchor tag related to article
    */
    _findAnchor: function(article) {
      var anchor = null;
      var selectors = ['a[rel=bookmark]', 'h1 > a', 'h2 > a', 'h3 > a', 'header > a'];

      for (var i = 0; i < selectors.length; i++) {
        var selector = selectors[i];
        var anchors = article.querySelector(selector + '[href]');
        if (anchors) {
          return anchors[0];
        }
      }

      return null;
    },
    /**
    * Search for footer of an article
    */
    _findFooter: function(article) {
      var selectors = ['.fyre','footer','.post-footer','.footer','.entry-footer','[class^="comment"]:not([class^=comment-count]):not([class^=comments-link]):not([class^=comments-number]):not(li)','.fb-comments','iframe[title=Disqus]','#disqus_thread'];
      var excludes = [
        '.post-meta-info'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var selector = selectors[i];
        var footer = article.querySelector(selector);

        if (footer) {
          if (footer.classList.contains('fb-comments')) {
            // Loop through previous elements because of WordPress Facebook Comments Plugin :/
            var ret = footer;
            var prev = footer;
            var findFBHeader = false;

            while (prev.previousElementSibling !== null) {
              if(prev.nodeName === 'P' && prev.previousElementSibling.nodeName === 'H3') {
                findFBHeader = true;
                prev = prev.previousElementSibling;
                break;
              } else {
                prev = prev.previousElementSibling;
              }
            }

            if (findFBHeader) {
              while (prev.previousElementSibling !== null) {
                prev = prev.previousElementSibling;
                if (prev.nodeName === 'H3') {
                  return prev;
                }
              }

              return ret;
            } else {
              return ret;
            }
          } else {
            return footer;
          }
        }
      }

      return null;
    },
    /**
    * Search for header of article
    */
    _findHeader: function(article) {
      var selectors = ['.main-title','header','.post-header','.post-title','h1','h2','h3','h4','h5','h6','.title','.headline'];

      for (var i = 0; i < selectors.length; i++) {
        var selector = selectors[i];
        var header = article.querySelector(selector);
        if (header) {
          return header;
        }
      }

      return null;
    },
    /**
    * Validate list of articles by making sure none of the article elements are in the invalidElements array
    */
    _validateArticles: function(articles) {
      if (!articles || !articles.length) return [];

      var validArticles = [];

      for (var i = 0; i < articles.length; i++) {
        var article = articles[i];
        var isValid = true;

        // Empty articles are invalid
        if (!article.innerText || article.innerText.trim() === '')
          continue;

        for (var j = 0; j < invalidElements.length; j++) {
          if (article === invalidElements[j]) isValid = false;
        }

        if (isValid) {
          if (!article.__header) {
            article.__header = this._findHeader(article);
          }

          article.__title = article.__header ? article.__header : null;
          article.__footer = this._findFooter(article);

          if (self._title) {
            article.__titleText = self.__title.innerText();
          }

          var anchor = (article.__header && article.__header.length) ? this._findAnchor(article.__header[0]) : null;

          if (anchor) {
            article.__anchor = anchor;
          } else {
            article.__anchor = this._findAnchor(article);
          }

          if (article.__anchor) {
            article.__url = article.__anchor.getAttribute('href');
          } else {
            article.__url = null;
          }

          if (!article.__url) {
            article.__url = window.location.href;
          }

          validArticles.push(article);
        }
      }

      return validArticles;
    },
    /**
    * Find all possible article elements
    */
    _findLeaves: function(baseElement, selector) {
      var query = selector;
      for (var i = 0; i < filters.length; i++) {
        query += ":not(" + filters[i] + ")";
      }

      var matches = baseElement.querySelectorAll(query);

      // Filter empty bodies here
      return matches || [];
    },

    /**
    * Find all articles on the page
    */
    findAll: function() {
      var main = document.querySelector('main, [role="main"]');
      var selector = main ? main : document.body;

      // Set up selector rules for articles
      leaves.push('article');
      leaves.push('.post');
      leaves.push('.entry-content');
      leaves.push('.post-content');
      leaves.push('.post_box');
      leaves.push('.post-item');
      leaves.push('.blog-post-wrapper');
      leaves.push('.type-post');
      leaves.push('#content');
      leaves.push('.blog_content');

      if (selector === document.body) {
        leaves.push('main .hentry');
        leaves.push('[role=main] .hentry');
        leaves.push('main .content');
        leaves.push('[role=main] .content');
      } else {
        leaves.push('.hentry');
        leaves.push('.content');
      }

      leaves.push('#post-content');
      leaves.push('#blog-content');
      leaves.push('.blog-post');

      this._findInvalidElements(selector);

      for (var i = 0; i < leaves.length; i++) {
        var articles = this._findLeaves(selector, leaves[i]);
        var validArticles = this._validateArticles(articles);

        if (validArticles.length > 0) {
          return validArticles;
        }
      }

      // Find elements containing three consecutive p tags
      var pTags = document.querySelectorAll('p');
      var articles = [];
      if (pTags && pTags.length) {
        for (var i = 0; i < pTags.length; i++) {
          var parentEl = pTags[i].parentNode;

          if (articles.indexOf(parentEl) > -1) continue;

          var children = parentEl.childNodes;
          var isArticle = false;
          var paragraphs = 0;

          for (var j = 0; j < children.length; j++) {
            if (children[j].tagName === 'P') paragraphs++;
            if (paragraphs >= 3) {
              isArticle = true;
              break;
            }
          }

          if (isArticle) {
            articles.push(parentEl);
          }
        }

        var validArticles = this._validateArticles(articles);
        if (validArticles.length > 0) {
          return validArticles;
        }
      }

      return [];
    },
    /**
    * Find first article on page
    */
    find: function() {
      var articles = this.findAll();
      if (articles && articles.length) {
        return articles[0];
      } else {
        return null;
      }
    },
    /**
    * Returns true if the page contains an article
    */
    hasArticles: function() {
      return this.findAll().length >= 1;
    }
  };

  return articles;
});
